import { getString } from "../../../../strings";
import { StyledDataWrapper } from '../../../molecules/UserPanel/StyledDataWrapper';
import { StyledText } from "../../../atoms/Text/StyledText";
import REGISTER_STATUS from '../../../constants/register_status.json';
import { REGISTER_STATUS_TEST } from "../UserPanelTournament.data";


const RegistrationStatus = ({ event, statusTextColor }) => {
    const isRejected =
        event?.user_register_status === REGISTER_STATUS['REJECTED'];

    const isReserve = event?.reserve && !isRejected;

    const color = isReserve
        ? '#E18872'
        : event?.user_register_status
        ? statusTextColor
        : '#E18872';

    const getStatusLabel = () => {
        if (isReserve) {
            return getString('userPanel_userPanelTournament_listaRezerwowa');
        }

        if (event?.user_register_status) {
            return REGISTER_STATUS_TEST[event.user_register_status];
        }

        return getString('userPanel_userPanelTournament_oczekujacy');
    };

    return (
        <StyledDataWrapper>
            <StyledText
                hasdeclaredfontsize="20px"
                hasdeclaredfontweight="600"
                hasdeclaredfontcolor="#4E6BAA"
            >
                {getString('userPanel_userPanelTournament_statusRejestracji')}
            </StyledText>

            <StyledText
                hasdeclaredfontsize="20px"
                hasdeclaredfontweight="600"
                hasdeclaredfontcolor={color}
                hasdeclaredpadding="0 0 0 8px"
            >
                {getStatusLabel()}
            </StyledText>
        </StyledDataWrapper>
    );
};

export default RegistrationStatus;